import { useCallback, useEffect, useState } from 'react';
import { useFormik } from 'shared/node_modules/formik';
import ShopInterface from 'shared/api/ShopInterface';
import { validationSchema, paymentFormKeys, savedAddressConverter } from '../utils';
export default function usePaymentInfoForm({ isKycPassed, submitFormHandler }) {
  const [initialValues, setInitialValues] = useState({
    [paymentFormKeys.COUNTRY]: 'US',
  });

  const formikValidation = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema(isKycPassed),
    onSubmit: submitFormHandler,
    isInitialValid: true,
    enableReinitialize: true,
  });

  const { values, setFieldValue } = formikValidation;

  useEffect(() => {
    setFieldValue(paymentFormKeys.STATE, '');
  }, [values[paymentFormKeys.COUNTRY]]);

  const checkUserAddressInfo = useCallback(async () => {
    const address = await ShopInterface.getAddressForPurchase();
    const savedAddress = address && savedAddressConverter(address);
    savedAddress && setInitialValues(savedAddress);
  }, []);

  useEffect(() => {
    if (isKycPassed) {
      checkUserAddressInfo();
    }
  }, [isKycPassed, checkUserAddressInfo]);

  return formikValidation;
}

